

:host {
  appearance: none !important;
  -webkit-appearance: none !important;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: var(--wrap-display, inline-flex);
  text-align: center;
  align-self: center;
  outline: none;
  border-radius: var(--border-radius, 0);
  contain: layout style;

  --width: auto;
  --height: auto;
  --padding-vertical: 0.56725em;
  --padding-horizontal: 1em;
  --padding: var(--padding-vertical) var(--padding-horizontal);
  --background: var(--theme-6);
  --color: var(--white);
  --border: none;
  --active-background: var(--theme-8);
  --active-color: var(--white);
  --active-border: none;
  --border: none;
  --border-radius: 0.2em;
  --font-size: 1rem;
  --white-space: nowrap;
  --text-decoration: none;
  --text-transform: uppercase;
}

:host([outline]) {
  --padding-vertical: calc(0.5em - 2px);
  --padding-horizontal: calc(1em - 2px);
  --background: transparent;
  --color: var(--theme-5);
  --border: 2px solid currentColor;
  --active-background: var(--theme-0);
  --active-color: var(--theme-7);
  --active-border: 2px solid currentColor;
}

:host([disabled]) {
  --background: var(--gray-5);
  --color: var(--gray-7);
  --border: none;
  --active-background: var(--gray-5);
  --active-color: var(--gray-7);
  --active-border: none;
}

:host([disabled]),
:host([disabled]) * {
  cursor: not-allowed !important;
}

:host([ghost]) {
  --padding-vertical: 0;
  --padding-horizontal: 0;
  --background: none;
  --color: var(--theme-5);
  --border: none;
  --active-background: none;
  --active-color: var(--theme-7);
  --active-border: none;
  line-height: 1;
}

:host([outline][invert]) {
  --background: transparent;
  --border: 2px solid currentColor;
  --active-background: var(--theme-0);
  --active-border: 2px solid currentColor;
}

:host([ghost][invert]) {
  --background: none;
  --color: var(--white);
  --border: none;
  --active-background: none;
  --active-color: var(--theme-1);
  --active-border: none;
}

:host([invert]) {
  --background: var(--white);
  --color: var(--theme-2);
  --border: none;
  --active-background: var(--theme-0);
  --active-color: var(--theme-5);
  --active-border: none;
}

:host([contrast]) {
  --background: var(--theme-7);
  --color: var(--white);
  --border: none;
  --active-background: var(--theme-9);
  --active-color: var(--theme-0);
  --active-border: none;
}

:host([contrast][outline]) {
  --border: 2px solid var(--white);
  --active-border: 2px solid var(--theme-0);
}

:host([contrast][invert]) {
  --active-color: var(--theme-5);
}

:host([pill]) {
  --border-radius: 1000px;
}

:host([circle]) {
  --border-radius: 100%;
}

:host([sidebar]) {
  --background: var(--gray-11);
  --active-background: var(--gray-10);
  --padding: 1rem 0.75rem;
  --border-radius: 0;
  overflow: hidden;
  position: relative;
}

:host([sidebar].no-indicator)::after {
  display: none !important;
}

:host([sidebar]),
:host([sidebar]) .button {
  transition: all .1s var(--ease) 0s;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 !important;
}

:host([sidebar]) ::slotted(midwest-icon) {
  margin: 0 auto !important
}

:host([sidebar][open]) {
  --background: var(--theme-10);
  --active-background: var(--theme-9);
  --padding: 1rem 0.5rem;
  --border-radius: 0;
}

:host([sidebar])::after {
  content: "";
  display: block;
  width: .25rem;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  opacity: 0;
  background: var(--theme-7);
  transform: translateX(.25rem);
  transition: all .2s var(--ease) 0s; 
}

:host([sidebar][open])::after {
  right: 0;
  opacity: 1;
  transform: translateX(0);
}

:host([sidebar]) .button {
  grid-template-columns: auto !important;
  grid-template-rows: auto !important;
  grid-gap: 0.5rem !important;
  align-items: center !important;
  justify-content: center !important;
  place-content: center !important;
  white-space: normal !important;
  width: 100%;
}

:host([sidebar]) .button midwest-label {
  line-height: 1.4;
  font-size: .75rem;
}

:host([sidebar]) .button ::slotted(*[slot="icon"]) {
  font-size: 1.5rem;
  margin: auto;
  color: var(--gray-0);
  --secondary: var(--gray-1);
  --tertiary: var(--gray-2);
}

:host([sidebar][open]) .button ::slotted(*[slot="icon"]) {
  color: var(--theme-0);
  --secondary: var(--theme-1);
  --tertiary: var(--theme-2);
}

:host([circle]) .button {
  width: calc(var(--font-size) * 4) !important;
  height: calc(var(--font-size) * 4) !important;
  display: flex !important;
  flex-direction: column !important;
  justify-content: center !important;
  align-items: center !important;
  padding: 0;
  line-height: 2;
}

:host([circle]) .button ::slotted([slot="icon"]) {
  margin-left: auto !important;
  margin-right: auto !important;
  font-size: calc(var(--font-size) * 3);
}

:host([size="tiny"]) {
  --font-size: 0.75rem;
}

:host([size="small"]) {
  --font-size: 0.875rem;
}

:host([size="medium"]) {
  --font-size: 1.125rem;
}

:host([size="large"]) {
  --font-size: 1.25rem;
}

:host([padding="tiny"]) {
  --padding-vertical: 0.25em;
  --padding-horizontal: 0.5em;
}

:host([padding="small"]) {
  --padding-vertical: 0.35em;
  --padding-horizontal: 0.875em;
}

:host([padding="medium"]) {
  --padding-vertical: 0.75em;
  --padding-horizontal: 1.25em;
}

:host([padding="large"]) {
  --padding-vertical: 1em;
  --padding-horizontal: 1.5em;
}

:host([icon][icon-only]),
:host([icon][only-icon]) {
  --padding: var(--padding-vertical);
}

:host([icon][icon-only]) .button,
:host([icon][only-icon]) .button {
  grid-template-columns: auto !important;
  grid-gap: 0 !important;
}

:host([icon][icon-only]) ::slotted([slot="icon"]),
:host([icon][only-icon]) ::slotted([slot="icon"]) {
  margin: 0;
}

:host(:not([disabled]):active),
:host([active]:not([disabled])) {
  transform: scale(0.975);
}

:host(.h-auto) {
  --height: 100%;
  --padding-vertical: 0;
}

:host .button {
  cursor: pointer;
  display: inline-flex;
  position: relative;
  align-items: center;
  text-transform: var(--text-transform);
  outline: 0;
  border: var(--border);
  background: var(--background);
  padding: var(--padding);
  width: var(--width);
  height: var(--height);
  vertical-align: baseline;
  vertical-align: -webkit-baseline-middle;
  text-decoration: var(--text-decoration);
  line-height: 1;
  white-space: var(--white-space);
  color: var(--color);
  letter-spacing: 0.125em;
  font-family: inherit;
  font-size: var(--font-size);
  font-weight: 600;
  border-radius: var(--border-radius, 0);
}

:host midwest-label,
:host([tag="button"]) .content {
  color: inherit;
  margin: 0;
  line-height: 1.4;
}

:host ::slotted([slot="icon"]) {
  color: currentColor;
}

:host ::slotted([slot="icon"].right) {
  order: 2;
}

:host a.button,
:host span.button {
  width: auto;
}

:host .button:hover,
:host .button:focus {
  border: var(--active-border);
  background-color: var(--active-background);
  color: var(--active-color);
}

:host([block]),
:host([block]) .button {
  display: flex;
  align-items: stretch;
  justify-content: center;
  width: 100%;
}

:host ::slotted(*) {
  line-height: 1 !important;
  font-family: inherit;
}

:host([icon]) .button {
  display: grid;
  align-items: center;
  justify-content: center;
  grid-template-columns: auto auto;
  grid-gap: 0.4em;
}

:host([icon][block]) .button {
  display: grid;
}

@media not all and (min-resolution:.001dpcm) { @media {
  :host([icon]) .button,
  :host([icon][block]) .button {
    display: flex;
  }

  :host([icon]) ::slotted(*[slot="icon"]) {
    margin-right: 0.4rem;
  }

  :host([icon]) ::slotted(*[slot="icon"].right) {
    margin-left: 0.4rem;
  }

  :host midwest-label, 
  :host([tag="button"]) .content {
    padding: 0.075em 0;
  }
}}

:host .button .processing {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 2em;
  width: 1em;
  height: 1em;
  margin: -0.25em -.35em -0.25em 0;
}

:host .button midwest-progress {
  display: inline-flex;
  color: var(--color);
}

:host ::slotted(img),
:host ::slotted(midwest-icon) {
  display: inline-block;
  float: none;
  width: 1em;
  height: 1em;
  font-size: 1.25em;
  margin: calc(var(--padding-vertical) * -0.5) 0 calc(var(--padding-vertical) * -0.5) calc(var(--padding-vertical) * -0.5);
  order: -1;
  margin-right: 0.1em;
  margin-left: -0.25em;
}

:host([size="small"]) ::slotted(img),
:host([size="small"]) ::slotted(midwest-icon) {
  margin-top: -0.35em;
}

:host ::slotted(img.right),
:host ::slotted(midwest-icon.right) {
  order: 2;
  margin-left: 0em;
  margin-right: -0.3em;
}

:host([ghost]) ::slotted(img),
:host([ghost]) ::slotted(midwest-icon) {
  font-size: 1.75em;
  margin-left: 0.125em !important;
}

:host([dark]) {
  --background: var(--theme-6);
  --color: var(--theme-11);
  --active-background: var(--theme-7);
  --active-color: var(--theme-11);
  --active-border: none;
}

:host([dark][contrast]) {
  --background: var(--theme-9);
  --color: var(--white);
  --active-background: var(--theme-8);
  --active-color: var(--white);
  --active-border: none;
}

:host([dark][disabled]) {
  --background: var(--gray-7);
  --color: var(--gray-9);
  --border: none;
  --active-background: var(--gray-7);
  --active-color: var(--gray-9);
  --active-border: none;
}

:host([dark][outline]) {
  --background: transparent;
  --color: var(--theme-0);
  --border: 2px solid var(--theme-0);
  --active-background: var(--theme-5);
  --active-color: var(--white);
  --active-border: 2px solid var(--theme-5);
}

:host([dark][outline][invert]) {
  --background: transparent;
  --color: var(--theme-0);
  --border: 2px solid var(--theme-0);
  --active-background: var(--theme-1);
  --active-color: var(--theme-7);
  --active-border: 2px solid var(--theme-1);
}

:host([dark][ghost]) {
  --padding: 0.05em 0 0.125em;
  --background: none;
  --color: var(--theme-3);
  --border: none;
  --active-background: none;
  --active-color: var(--theme-4);
  --active-border: none;
}

:host([dark][ghost][invert]) {
  --padding: 0.05em 0 0.125em;
  --background: none;
  --color: var(--theme-0);
  --border: none;
  --active-background: none;
  --active-color: var(--theme-1);
  --active-border: none;
}

:host([dark][ghost][disabled]) {
  --active-color: var(--theme-3);
}

:host([dark][ghost][invert][disabled]) {
  --active-color: var(--theme-0);
}

